const ITEMS = [
  "Conception paramétrique",
  "Rétro-ingénierie",
  "Impression haute précision",
  "Prototypage rapide",
  "PLA recyclé & PETG",
  "Fichiers .STEP & .STL fournis",
  "Lancement octobre 2026",
];

export default function AtelierMarquee() {
  return (
    <section className="overflow-hidden border-y border-black/5 bg-mist py-5" aria-label="Savoir-faire de l'atelier">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {ITEMS.map((t, i) => (
              <span
                key={`${copy}-${i}`}
                className="flex items-center whitespace-nowrap font-mono text-xs uppercase tracking-[0.25em] text-neutral-500"
              >
                <span className="px-8">{t}</span>
                <span className="inline-block h-1 w-1 rounded-full bg-accent" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
